<!-- login.component.html -->
<div class="main-container">
  <div class="login-box">
    <div class="bg"></div>
    <div class="form-box">
      <div class="form-tab">
        <h3 class="title">极阅云远程影像诊断系统</h3>
        <div class="tab">
          <div class="tab-item" [ngClass]="activeTab === 'login' ? 'active' : ''" (click)="activeTab = 'login'">登录</div>
          <div class="tab-item" [ngClass]="activeTab === 'register' ? 'active' : ''" (click)="activeTab = 'register'">注册</div>
        </div>
        <div class="content">
          <div class="box login">
            <nz-row class="login-container">
              <nz-col [nzSpan]="24" class="right-panel">
                <form nz-form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                  <div class="form-title">用户名</div>
                  <nz-form-item>
                    <nz-form-control [nzErrorTip]="'请输入用户名'">
                      <nz-input-group nzSize="large">
                        <input nz-input formControlName="username" placeholder="请输入用户名" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>

                  <div class="form-title">密码</div>
                  <nz-form-item>
                    <nz-form-control [nzErrorTip]="'请输入密码'">
                      <nz-input-group nzSize="large">
                        <input nz-input formControlName="password" type="password" placeholder="请输入密码" />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-row>
                    <nz-col [nzSpan]="12" style="line-height: 40px">
                      <label nz-checkbox formControlName="rememberMe"> 记住我 </label>
                    </nz-col>
                    <nz-col [nzSpan]="12" class="text-right" style="line-height: 40px">
                      <button nz-button nzType="link">忘记密码？点此找回</button>
                    </nz-col>
                  </nz-row>

                  <nz-form-item style="padding-top: 20px">
                    <button nz-button nzType="primary" nzSize="large" class="full-width-button" [disabled]="!loginForm.valid">登&nbsp;&nbsp;录</button>
                  </nz-form-item>
                </form>
              </nz-col>
            </nz-row>

            <nz-divider>
              <span style="color: #bdc1c5">其他登录方式</span>
            </nz-divider>

            <nz-row>
              <nz-col [nzSpan]="24">
                <button nz-button nzSize="large" class="full-width-button scan-qr" style="margin-top: 20px">
                  <img src="assets/wechat-fill.svg" alt="" style="height: 30px" />
                  &nbsp;微信扫码登录
                </button>
              </nz-col>
            </nz-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
